/*
    新增頁面 ADD
    /XXX/XXX/add
    編輯頁面 EDIT
    /XXX/XXX/edit/(:id)
    唯獨模式 READ ONLY
    /XXX/XXX/read-only/(:id)
*/

/* 登入與ROOT */
export const ENTRANCE_MEMBER_ROOT_ROUTER = `member`;
export const ENTRANCE_EMPLOYEE_ROOT_ROUTER = `employee`;
export const LOGIN_ROOT_ROUTER = `/login/`;
export const LOGIN_CAPTCHA_ROOT_ROUTER = `/login-captcha/`;
export const AUTH_ROOT_ROUTER = `/auth/`;
export const MEMBER_ROOT_ROUTER = `/member/`;
export const EMPLOYEE_ROOT_ROUTER = `/employee/`;
export const TEST_ROUTER = `/test/`;
/* 功能尚未開放公告頁（免登入） */
export const COMING_SOON_ROOT_ROUTER = `/coming-soon/`;

/* 會員頁 */
export const MEMBER_PROFILE_ROUTER = `/member/profile/`;
export const MEMBER_PROFILE_CARD_ROUTER = `/member/profile/card/`;
export const MEMBER_PROFILE_WORKOUT_ROUTER = `/member/profile/workout/`;

/* 會員量身頁 */
export const MEASURE_ROUTER = `/member/measure/`;
export const MEASURE_DASHBOARD_ROUTER = `/member/measure/dashboard/`;
export const MEASURE_DETAIL_ROUTER = `/member/measure/detail/`;
export const MEASURE_REPORT_ROUTER = `/member/measure/report/`;

/* 量身結果頁 目前教練頁面專用 */
export const MEASURE_RESULT_ROUTER = `/member/measure/result/`;
export const MEASURE_TRANSCRIPT_ROUTER = `/member/measure/transcript/`;
export const MEASURE_EVALUATION_ROUTER = `/member/measure/evaluation/`;

/* 教練量身頁 */
export const EMPLOYEE_MEASURE_ROUTER = `/employee/measure/`;
export const EMPLOYEE_MEASURE_RESULT_ROUTER = `/employee/measure/result/`;

/* 智能系統頁 */
export const MEMBER_SMART_FITNESS_BAND_ROUTER = `/member/smart-fitness-band/`;
export const EMPLOYEE_SMART_FITNESS_BAND_ROUTER = `/employee/smart-fitness-band/`;

/* 兌換點數贈品 */
export const MEMBER_REDEEM_ROUTER = `/member/redeem/`;
export const MEMBER_REDEEM_HISTORY_ROUTER = `/member/redeem/history/`;
export const MEMBER_REDEEM_PRODUCT_SELECT_ROUTER = `/member/redeem/product-select/`;
export const MEMBER_REDEEM_CONFIRM_ROUTER = `/member/redeem/confirm/`;
export const MEMBER_REDEEM_PRODUCT_GUIDE_ROUTER = `/member/redeem/product-guide/`;

/* 循環訂單更換商品 */
export const MEMBER_CYCLE_PURCHASE_ROUTER = `/member/cycle-purchase/`;
export const MEMBER_CYCLE_PURCHASE_PRODUCT_SELECT_ROUTER = `/member/cycle-purchase/product-select/`;
export const MEMBER_CYCLE_PURCHASE_CONFIRM_ROUTER = `/member/cycle-purchase/confirm/`;
export const MEMBER_CYCLE_PURCHASE_SUCCESS_ROUTER = `/member/cycle-purchase/success/`;
export const MEMBER_CYCLE_PURCHASE_PENDING_CHANGE_ROUTER = `/member/cycle-purchase/pending-change/`;

/* DashBoard */
export const MEMBER_DASHBOARD_ROUTER = `/member/dashboard/`;